import { createSelector } from "@reduxjs/toolkit";
import { TASK_TYPES } from "@regal-voice/shared-types";

import { selectTasks } from "Services/state/tasks/Selectors";

const selectConferenceState = (state: RootState) => {
    return state.conference;
};

/**
 * These selectors are still needed because we still have a reliance on the Twilio device.
 *
 * @remarks
 * Once we clean up the device dependencies, we could potentially rename or refactor these selectors.
 */
export const selectConference = createSelector(selectConferenceState, (conferenceState) => {
    return conferenceState.activeConference.value;
});

export const selectActiveConferenceTask = createSelector(selectConference, selectTasks, (conference, tasks) => {
    // TODO, where should we put this...
    // this is really the only value we need from the conference
    const conferenceTaskId = conference.connectionParams?.taskSid;
    if (conferenceTaskId) {
        const active = Object.values(tasks).find((task) => {
            return (
                (Boolean(task.taskSid) && task.taskSid === conferenceTaskId) ||
                (task.attributes.taskType === TASK_TYPES.TAKEOVER_CALL &&
                    task.attributes.originating_task_sid === conferenceTaskId) ||
                (Boolean(conference.conferenceSid) && conference.conferenceSid === task.attributes.conferenceSid)
            );
        });

        return active;
    }
});

//////////////////////////////////////////

/**
 * These selectors that we have snapshot versions of and can be removed
 *
 * @remarks
 * remove when we clean up the rolloutStateSse flags
 * */

export const selectDeviceCallSid = createSelector(selectConference, (conference) => conference.deviceCallSid);
